import { FC } from 'react';
import { Dialog } from '../components/dialog';
import { Dialogs } from '../constants/dialogs';
import { useDialog } from '../contexts/dialog.context';
import { Button, DialogActions, Typography } from '@mui/material';
import { Outlet } from 'react-router-dom';

export const DialogesLayout: FC = () => {
  const { closeDialog } = useDialog();

  return (
    <>
      <Outlet />
      <Dialog dialog={Dialogs.PLAN_ACTIVITIES} title="Congrats!">
        <Typography variant="body1" gutterBottom>
          Your activity has been successfully planned. Check your home screen to see if you need to schedule another activity for the week.
        </Typography>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={closeDialog}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog dialog={Dialogs.FINISH_TOTURIALS} title="Tutorials Completed">
        <Typography variant="body1" gutterBottom>
          You have finished your tutorials. Great job!
        </Typography>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={closeDialog}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog dialog={Dialogs.REGISTRATION_SUCCESS} title="Congratulations!">
        <Typography variant="body1" gutterBottom>
          You have successfully completed the registration process. You can now schedule activities for the week.
        </Typography>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={closeDialog}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
